import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { canActivateAuthGuard } from '@okta/okta-angular';
import { EnvironmentService } from './services/environment.service';

export const authenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const environmentService = inject(EnvironmentService);

  if (environmentService.ignoreScopes) {
    return true;
  }

  return canActivateAuthGuard(route, state);
};
